// extracted by mini-css-extract-plugin
export default {"Root":"JoinSection_Root__-zuCd","Title":"JoinSection_Title__zsytj","SubTitle":"JoinSection_SubTitle__dNUXR","Button":"JoinSection_Button__dLsn8"};